import * as Yup from 'yup';
import { DictionaryDirpType } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryDirpType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
